import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import ReadTimeStrip from "@/components/site/ReadTimeStrip";
import EquityCommitment from "@/components/site/EquityCommitment";
import ThreeAsks from "@/components/site/ThreeAsks";
import StrategicAlignment from "@/components/site/StrategicAlignment";
import LocalContext from "@/components/site/LocalContext";
import TwoProngedStrategy from "@/components/site/TwoProngedStrategy";
import TradePipeline from "@/components/site/TradePipeline";
import MultigenerationalStory from "@/components/site/MultigenerationalStory";
import SeniorCarePipeline from "@/components/site/SeniorCarePipeline";
import IntakeFramework from "@/components/site/IntakeFramework";
import ReferralNetwork from "@/components/site/ReferralNetwork";
import GapAnalysis from "@/components/site/GapAnalysis";
import CDBGAlignment from "@/components/site/CDBGAlignment";
import BudgetGate from "@/components/site/BudgetGate";
import ImplementationStrategy from "@/components/site/ImplementationStrategy";
import FederalStrategy from "@/components/site/FederalStrategy";
import ImageGallery from "@/components/site/ImageGallery";
import MunicipalPartnership from "@/components/site/MunicipalPartnership";
import ContactForm from "@/components/site/ContactForm";
import StickyCTA from "@/components/site/StickyCTA";
import Footer from "@/components/site/Footer";
import LineageNote from "@/components/site/LineageNote";
import NDAGate from "@/components/site/NDAGate";

export default function LandingPage() {
  return (
    <NDAGate proposal="baytown">
    <main data-testid="landing-page" className="bg-[#F9F7F1] text-[#0A192F]">
      <Navigation />
      <Hero />
      <ReadTimeStrip />
      <LineageNote />
      {/* ----- Opening: Equity · Three Asks ----- */}
      <EquityCommitment />
      <ThreeAsks />
      <StrategicAlignment />
      {/* ----- The Need: Baytown context + program mechanics ----- */}
      <LocalContext />
      <TwoProngedStrategy />
      <TradePipeline />
      <MultigenerationalStory />
      <SeniorCarePipeline />
      <IntakeFramework />
      <ReferralNetwork />
      <GapAnalysis />
      <CDBGAlignment />
      {/* ----- The Money + The Plan + The Federal Win ----- */}
      <BudgetGate />
      <ImplementationStrategy />
      <FederalStrategy />
      {/* ----- Close: gallery, ask, contact ----- */}
      <ImageGallery />
      <MunicipalPartnership />
      <ContactForm />
      <StickyCTA />
      <Footer />
    </main>
    </NDAGate>
  );
}
